__turbopack_context__.v({
  "blockTwoColumn": "TextLockup-module-scss-module__-F2rka__blockTwoColumn",
  "buttonWrapper": "TextLockup-module-scss-module__-F2rka__buttonWrapper",
  "copy": "TextLockup-module-scss-module__-F2rka__copy",
  "eyebrow": "TextLockup-module-scss-module__-F2rka__eyebrow",
  "hasRichHeadline": "TextLockup-module-scss-module__-F2rka__hasRichHeadline",
  "headline": "TextLockup-module-scss-module__-F2rka__headline",
  "lockup": "TextLockup-module-scss-module__-F2rka__lockup",
  "textLockup": "TextLockup-module-scss-module__-F2rka__textLockup",
});
